import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router';
import { AboutLayoutTypesClassic, TemplateClassNames } from '../../../../types/template-layouts';
import { getTextValue } from '../../../../utils/utils';
import { ParamsProps } from '../../live-event';
import { ModuleMap, PageModule, PageModuleType } from '../../../../types/working-model';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { getStylingOverrides } from '../../utils';
import React from 'react';
import './about.scss';

interface AboutProps {
	module: PageModule;
	template: TemplateClassNames
}

const About = React.forwardRef<HTMLDivElement, AboutProps>(({ module, template }, ref) => {
	const params: ParamsProps = useParams();
	const language = params?.language || 'en';

	const { content, styling_overrides } = module;
	const layout_type = content?.layout_type || AboutLayoutTypesClassic.standard;
	const {
		backgroundColor,
		backgroundImg,
		titleOverrides,
		descriptionOverrides,
		customHeadingOverrides
	} = getStylingOverrides(styling_overrides);
	const imagesLength = 1;

	const renderGallery = () => {
		const gallery = [];
		for (let i = 0; i < imagesLength; i += 1) {
			gallery.push(<img key={i} src={content.image} alt="" aria-hidden="true" width="275" height="220" />);
		}

		return gallery;
	};

	const { custom_heading, description, title } = getTextValue(content, language);

	return module.is_on && content && (
		<section
			id={ModuleMap[PageModuleType.about]}
			className={classNames(
				'about-us',
				`about-us-${layout_type}`,
				template,
				backgroundColor
			)}

			ref={ref}
		>
			<div className="module-container" style={backgroundImg}>
				<div className="about-us-text">
					<TypographyItem className={classNames('evt-caption-1 about-us-custom-heading', customHeadingOverrides)} tagName="p">
						{custom_heading}
					</TypographyItem>
					<div className="about-us-text-inner">
						<TypographyItem className={classNames('evt-heading-2 about-us-title', titleOverrides)} tagName="h2">
							{title}
						</TypographyItem>
						<TypographyItem className="evt-body-text-1">
							<ReactMarkdown className={classNames('about-us-description', descriptionOverrides)} source={description} />
						</TypographyItem>
					</div>
				</div>
				<div className={classNames('about-us-gallery-wrapper', `about-us-gallery-wrapper-${imagesLength}`)}>
					<div className={classNames('about-us-gallery', `about-us-gallery-${imagesLength}`)}>
						{renderGallery()}
					</div>
				</div>
			</div>
		</section>
	);
});

About.displayName = 'About';

export default About;
